const AUTH_TYPES = {
  RESET_STATE: "RESET_STATE",
  RESET_FORMS: "RESET_FORMS",

  LOGIN_BEGIN: "LOGIN_BEGIN",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",

  LOGOUT_BEGIN: "LOGOUT_BEGIN",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  LOGOUT_FAILURE: "LOGOUT_FAILURE",

  SIGNUP_BEGIN: "SIGNUP_BEGIN",
  SIGNUP_SUCCESS: "SIGNUP_SUCCESS",
  SIGNUP_FAILURE: "SIGNUP_FAILURE",

  SET_PASSCODE: "SET_PASSCODE",

  SEND_RESET_LINK_BEGIN: "SEND_RESET_LINK_BEGIN",
  SEND_RESET_LINK_SUCCESS: "SEND_RESET_LINK_SUCCESS",
  SEND_RESET_LINK_FAILURE: "SEND_RESET_LINK_FAILURE",

  RESET_PASSWORD_BEGIN: "RESET_PASSWORD_BEGIN",
  RESET_PASSWORD_SUCCESS: "RESET_PASSWORD_SUCCESS",
  RESET_PASSWORD_FAILURE: "RESET_PASSWORD_FAILURE",

  SUBMIT_PASSCODE_BEGIN: "SUBMIT_PASSCODE_BEGIN",
  SUBMIT_PASSCODE_SUCCESS: "SUBMIT_PASSCODE_SUCCESS",
  SUBMIT_PASSCODE_FAILURE: "SUBMIT_PASSCODE_FAILURE",

  FETCH_SCHOOLS_BEGIN: "FETCH_SCHOOLS_BEGIN",
  FETCH_SCHOOLS_SUCCESS: "FETCH_SCHOOLS_SUCCESS",
  FETCH_SCHOOLS_FAILURE: "FETCH_SCHOOLS_FAILURE",

  FETCH_SCHOOLS_BY_PASSCODE_BEGIN: "FETCH_SCHOOLS_BY_PASSCODE_BEGIN",
  FETCH_SCHOOLS_BY_PASSCODE_SUCCESS: "FETCH_SCHOOLS_BY_PASSCODE_SUCCESS",
  FETCH_SCHOOLS_BY_PASSCODE_FAILURE: "FETCH_SCHOOLS_BY_PASSCODE_FAILURE",

  FETCH_ROLES_BEGIN: "FETCH_ROLES_BEGIN",
  FETCH_ROLES_SUCCESS: "FETCH_ROLES_SUCCESS",
  FETCH_ROLES_FAILURE: "FETCH_ROLES_FAILURE",

  FETCH_GRADES_BEGIN: "FETCH_GRADES_BEGIN",
  FETCH_GRADES_SUCCESS: "FETCH_GRADES_SUCCESS",
  FETCH_GRADES_FAILURE: "FETCH_GRADES_FAILURE",

  CREATE_GROUP_BEGIN: "CREATE_GROUP_BEGIN",
  CREATE_GROUP_SUCCESS: "CREATE_GROUP_SUCCESS",
  CREATE_GROUP_FAILURE: "CREATE_GROUP_FAILURE",

  FETCH_PROFILE_BEGIN: "FETCH_PROFILE_BEGIN",
  FETCH_PROFILE_SUCCESS: "FETCH_PROFILE_SUCCESS",
  FETCH_PROFILE_FAILURE: "FETCH_PROFILE_FAILURE",

  UPDATE_PROFILE_BEGIN: "UPDATE_PROFILE_BEGIN",
  UPDATE_PROFILE_SUCCESS: "UPDATE_PROFILE_SUCCESS",
  UPDATE_PROFILE_FAILURE: "UPDATE_PROFILE_FAILURE",
};

export default AUTH_TYPES;
